// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.d.ts.
import type { ClientLogEntry } from '../clientLogCapture';
import { SUPPORT_LOGGING_HEADER } from '../supportLoggingStore';

// Client log capture for support. The backend only offers it where the deployment sets
// CLIENT_LOG_CAPTURE_ENABLED; elsewhere getLogCaptureAvailable() is false and the UI hides it.
export const adminBackendServiceLogCaptureMixin = {
  getLogCaptureAvailable(): Promise<boolean> {
    return this.authApiGetAuthed(
      'admin/log-capture',
      'Network error while checking log capture',
      (json) => json?.available === true,
    );
  },

  // Admin Settings -> Support -> "Capture my logs": a 30-minute signed token for this admin.
  startSupportLogging(): Promise<{ token: string; expiresAt: number }> {
    return this.authPostJson('admin/support-logging/start');
  },

  stopSupportLogging(token: string): Promise<void> {
    return this.authFetchPromise(async (authToken) => {
      await this.authenticatedFetch(this.apiURL('admin/support-logging/stop'), {
        method: 'POST',
        headers: { Authorization: `Bearer ${authToken}`, [SUPPORT_LOGGING_HEADER]: token },
      });
    });
  },

  /** Resolves false once the backend refuses (window over, or capture off on this deployment). */
  sendSupportClientLogs(token: string, entries: ClientLogEntry[]): Promise<boolean> {
    return this.authFetchPromise(async (authToken) => {
      const response = await this.authenticatedFetch(
        this.apiURL('admin/support-logging/client-logs'),
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${authToken}`, [SUPPORT_LOGGING_HEADER]: token },
          body: JSON.stringify({ source: 'admin-web', entries }),
        },
      );
      return ![401, 403, 404].includes(response.status);
    });
  },
};
